// import { CloudGame, pc } from "packages/js-sdk";
import { countTargetTime, isReachTarget, secondToMs, showDownloadBox, copyText } from "./game-service";
import AdjustSDK from "@/util/adjustReport.js";
import { getCosH5Address, LANG } from "@/constant";
import { postApiRtt } from '@/util/performance';

var _this;

// 初始化handler
function initErrorHandler(obj) {
  _this = obj;
}

// webrtc不支持弹窗引用
export function toggleConnErrDialog(_this, desc = "") {
  // _this
  //   .$dialogBox({
  //     content:
  //     _this.$t("error.browserError").toString(),
  //     confirm: "Copy Link",
  //     cancel: "商店下载",
  //   })
  //   .then((data) => {
  //     if (data == "confirm") {
  //       console.log("copylink");
  //       _this.$copyText(window.location.href);
  //       _this.$toast.open("复制成功");
  //     } else if (data == "cancel") {
  //       console.log("商店下载");
  //     }
  //   })
  //   .catch(() => {});
  _this
    .$dialogBox({
      title: _this.$t("error.hint").toString(),
      gameId: _this.gameId,
      content:
        _this.$t("error.browserError").toString() + (desc ? ": " + desc : ""),
      confirm: _this.$t("error.copyLink").toString(),
      // cancel: _this.$t("error.exit").toString(),
      showCloseBtn: false,
      // width: 265,
      needForceLandscape: _this.needForceLandscape,
    })
    .then((data) => {
      if (data == "confirm") {
        copyText(window.location.href, _this);
      }
    });
}

// 监听错误码，弹出错误弹窗
function errorEventHandler() {
  console.log("errorEventHandler");
  //监听长时间不操作
  // initMouseMoveMonitor();

  // 处理webrtc不支持
  // CloudGame.event(CloudGame.EVENT.RTCPEERCONNECTIONERROR, () => {
  //   console.log("[RTCPEERCONNECTION_ERROR]");
  //   toggleConnErrDialog();
  // });
  const { EEvent, EInnerEvent, EDomEvent } = window.CloudGame.Enum;

  window.cg.event.regist({
    [EEvent.ReconnectError]: (error) => {
      if (error == "offline-error") {
        if (!document.getElementById('network-error-dialog')) {
          showDefaultDialog("Network Error", "network-error-dialog");
        }
      } 
    },
    [EDomEvent.NetChange]: ({ online }) => {
      if (!online) {
        if (!document.getElementById('network-error-dialog')) {
          showDefaultDialog("Network Error", "network-error-dialog");
        }
      }
    },
  });

  window.cg.event.regist({
    [EEvent.NoDevice]: (err) => {
      // 无设备提示框
      _this
        .$dialogBox({
          title: _this.$t("error.hint").toString(),
          gameId: _this.gameId,
          content: _this.$t("error.noDevice").toString(),
          confirm: _this.$t("error.exit").toString(),
          // width: 330,
          // showCloseBtn: false,
          needForceLandscape: _this.needForceLandscape,
        })
        .then((data) => {
          exitGame();
        });
      // AdjustSDK.reportEvent("error_device_none");
      postApiRtt("error_device_none");
    },
  });

  // eslint-disable-next-line
  // @ts-ignore
  // CloudGame.event(CloudGame.INNER_EVENT.NO_OPRATE, () => {
  //   _this.errorInfo = { code: 0x99, msg: "" };
  // });
  window.cg.event.regist({
    [EEvent.Timeout]: (error) => {
      if (window.localStorage.getItem("cg_start_game_success") == "true") {
        showDefaultDialog();
      } else {
        toggleConnErrDialog(_this);
        postApiRtt("error_link_timeout");
      }
      // AdjustSDK.reportEvent("error_link_timeout");
    },

    [EEvent.TokenError]: (error) => {
      showDefaultDialog();
    },

    [EEvent.WebRTCError]: (error) => {
      if (error === "offer_sdp_type") {
        // toggleConnErrDialog(JSON.stringify(error));
        toggleConnErrDialog(_this);
        // AdjustSDK.reportEvent("error_offer_sdp_type");
        postApiRtt("error_offer_sdp_type");
        return;
      }
      if (_this.gameType == 1) {
        return;
      }
      showDefaultDialog();
    },

    [EInnerEvent.PeerConnectionStatus]: (status) => {
      if (status === "peer-connection-create-fail") {
        // toggleConnErrDialog(status);
        toggleConnErrDialog(_this);
        postApiRtt("error_peer_connection_create_fail");
        // AdjustSDK.reportEvent("error_peer_connection_create_fail");
      }
      if (["peer-connection-fail", "peer-connection-closed", "peer-connection-disconnected"].includes(status)) {
        if (_this.gameType == 1) {
          return;
        }
        showDefaultDialog();
        postApiRtt(`error_${status}`);
      }
    },
  });

  window.cg.event.regist({
    [EEvent.Error]: (error) => {
      let val = error.code;
      console.log(val, error);
      if (val === 4103 || val === 0x1102 || val === 1001) {
        // 网络错误提示框
        exitGame();
        _this
          .$dialogBox({
            title: _this.$t("error.hint").toString(),
            gameId: _this.gameId,
            content: _this.$t("error.linkFail").toString(),
            confirm: _this.$t("error.relink").toString(),
            cancel: _this.$t("error.exit").toString(),
            showCloseBtn: false,
            // width: 265,
            needForceLandscape: _this.needForceLandscape,
          })
          .then((data) => {
            if (data == "confirm") {
              restartGame();
            } else if (data == "cancel") {
              exitGame();
            }
          });
        if (val == 1001) {
          postApiRtt("error_device_abnormal");
        } else {
          postApiRtt("error_link_fail");
        }
        // AdjustSDK.reportEvent("error_link_fail");
      }
      // 时长耗尽
      else if (val === 1006) {
        showDownloadBox(3, _this.gameId, _this, "overTime");
        postApiRtt("error_notime");
        // getCosH5Address(`download-box-${LANG}-3`, _this.gameId).then(
        //   (data) => {
        //     _this.$downloadBox({ imageUrl: data });
        //   }
        // );
      }
      // 被其他设备顶掉
      else if (val === 1102) {
        _this
          .$dialogBox({
            gameId: _this.gameId,
            content: _this.$t("error.multiDevice").toString(),
            confirm: "OK",
            // width: 320,
            showCloseBtn: false,
            needForceLandscape: _this.needForceLandscape,
          })
          .then((data) => {
            if (data == "confirm") {
              // exitGame();
            }
          });
      }
      else if (val === 1002) {
        return;
      } else {
        _this
          .$dialogBox({
            gameId: _this.gameId,
            content: _this.$t("error.linkFail").toString(),
            confirm: _this.$t("error.relink").toString(),
            // cancel: _this.$t("error.exit").toString(),
            showCloseBtn: false,
            // width: 265,
            needForceLandscape: _this.needForceLandscape,
          })
          .then((data) => {
            if (data == "confirm") {
              restartGame();
            } else if (data == "cancel") {
              // exitGame();
            }
          });
      }
    },
    [EEvent.SocketConnectClosed]: (error) => {
      console.warn('SocketConnectClosed:', error);
      if (_this.gameType == 1) {
        return;
      }
      showDefaultDialog();
      postApiRtt(`error_socket_connect_closed_${JSON.stringify(error)}`);
    },
    [EEvent.SocketConnectError]: (error) => {
      console.warn('SocketConnectError:', error);
      if (_this.gameType == 1) {
        return;
      }
      showDefaultDialog();
      postApiRtt(`error_socket_connect_${JSON.stringify(error)}`);
    },
    [EEvent.GameConfigError]: () => {
      postApiRtt("error_game_config");
    },
    [EEvent.AudioInputError]: ({ type }) => {
      postApiRtt(`error_audio_input_${type}`);
    },
    [EEvent.ExtError]: (error) => {
      console.warn('ExtError:', error);
      postApiRtt(`error_ext_${JSON.stringify(error)}`);
    },
  });
}

var actionFlag = false;
var targetTime = 0;
var noActionInterval = null;
var noActionTime = 600; // 单位s （10分钟不操作则视为挂机）
var INTERVAL_TIME = 5000;

// 监听逻辑
function initMouseMoveMonitor() {
  refreshTargetTime();
  window.addEventListener("click", mouseMonitorListener, false);
  // 由于这个时间可能会很长，所以不使用timeout

  if (noActionInterval) {
    clearInterval(noActionInterval);
  }

  noActionInterval = setInterval(() => {
    // actionFlag = true;
    if (isReachTarget(targetTime)) {
      triggerNoAction();
    }
  }, INTERVAL_TIME);
}

// 移除不操作监听
function removeMouseMoveMonitor() {
  window.removeEventListener("click", mouseMonitorListener, false);
  clearInterval(noActionInterval);
}

// 重置监听
function refreshTargetTime() {
  targetTime = countTargetTime(secondToMs(noActionTime));
}

function mouseMonitorListener() {
  // if (actionFlag) {
    refreshTargetTime();
    // actionFlag = false;
  // }
}

function triggerNoAction() {
  // CloudGame.pureQuitGame();
  setTimeout(() => {
    window.cg.game.freeDevice();
    window.cg.game.quitGame();
  }, 1000 * 180);

  removeMouseMoveMonitor();
  _this
    .$dialogBox({
      title: _this.$t("error.hint").toString(),
      content: _this.$t("error.noOperate").toString(),
      confirm: _this.$t("error.relink").toString(),
      cancel: _this.$t("error.exit").toString(),
      // width: 320,
      showCloseBtn: false,
      needForceLandscape: _this.needForceLandscape,
      textAlign: "center",
      gameId: _this.gameId,
    })
    .then((data) => {
      if (data == "confirm") {
        window.cg.game.exitFullscreen();
        restartGame();
      } else if (data == "cancel") {
        exitGame();
      }
    });
  postApiRtt("error_nooperation");
}

// 重启游戏,不杀容器
export async function restartGame() {
  // await window.cg.game.quitGame();
  _this.$loadingBox.open();
  window.location.reload();
  // _this.$loadingBox.hide();
}

// 退出游戏
export async function exitGame() {
  await window.cg.game.freeDevice();
  await window.cg.game.quitGame();
  // window.location.href = `/hok/home`;
  // window.opener = null;
  // window.location.href = "about:blank";
  // window.close();
}

// 展示默认弹框
export function showDefaultDialog(param = "", dialogID = "default-dialog") {
  _this
    .$dialogBox({
      title: _this.$t("error.hint").toString(),
      gameId: _this.gameId,
      content:
        _this.$t("error.linkFail").toString() + (param ? ": " + param : ""),
      confirm: _this.$t("error.relink").toString(),
      cancel: _this.$t("error.exit").toString(),
      showCloseBtn: false,
      // width: 265,
      needForceLandscape: _this.needForceLandscape,
      dialogID: dialogID,
    })
    .then((data) => {
      if (data == "confirm") {
        restartGame();
      } else if (data == "cancel") {
        exitGame();
      }
    });
}

export function showDevelopingDialog() {
  _this.$dialogBox({
    title: _this.$t("error.hint").toString(),
    gameId: _this.gameId,
    content: _this.$t("menu.developing").toString(),
    confirm: _this.$t("menu.dialogRestartAffirmText").toString(),
    needForceLandscape: _this.orientation,
  })
}

const CGErrorHandler = {
  initErrorHandler,
  errorEventHandler,
  initMouseMoveMonitor,
};

export default CGErrorHandler;
